module.exports = __webpack_public_path__ + "img/logo.1d0e9fb6.png";